
<div *ngIf="privilegesView==='AccessDenied'" class=" outside-container  mt-4" >
  <div class="box-container">
    <div class="container">
      <div *ngIf="privilegesView==='AccessDenied'" class="  d-flex justify-content-center" >

  <img src="../../../assets/images/AccessDeniedError.png" alt="">
</div>

 </div>
</div>
</div>
<div *ngIf="privilegesView==='VAMD'" class="outside-container mt-4">
    <div class="box-container ">
        <div class="container">
            <div class="title ">

              <div class="row">
                <div class=" col-md-2  " ><div class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;">⬅️</div></div>  
               <div class="col-md-7 d-flex justify-content-center">Data Settings</div>
               <div class=" col-md-3 row ">
                 <div class="d-flex justify-content-end">
                  <button *ngIf="showDataEncrypt" class="btn btn-outline-primary btn-sm " (click)="onAddDataEncrypt()"><img src="assets/images/Add_24.png"></button>
                 
               </div>
                </div>
              </div>
            
            </div> 
            </div>
            </div>
          </div>
          <div *ngIf="privilegesView==='VAMD'" class="outside-container ">
            <div class="box-container ">
                <div class="container ">
                  <div class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
                 
                 
                    <div class="col-md-2  "  style="background-color: #d2e1f5; border-radius: 4px; content: right; padding-top: 10px; height:70vh;overflow-y: auto; ">
                      <div class="col-md-12 ">
                      <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickDataEncrypt()"     [ngClass]="{'activity' :showDataEncrypt}">Data Encryption Keys</span></span>
                     

                    </div>
                      
                    </div>

                   <div class="col-md-10" style="height:70vh; overflow-y: auto;">
                     <div *ngIf="showDataEncrypt" class="col-md-12 card" style="min-height: 100%;" >

                      <div class=" row mt-3 " style="padding: 10px;">
                       
                        
                        <div class="col-md-12 " >
                         
                          <table mat-table
                          [dataSource]="DataEncrypt" multiTemplateDataRows style="background-color: transparent;">
                         
              
                           <ng-container matColumnDef="keyStoreName">
                             <th mat-header-cell *matHeaderCellDef>Key Store Name</th>
                             <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" (click)="rowdataEncryptorClick(element)"> {{element?.ksName}} </td>
                           </ng-container>

                          <ng-container matColumnDef="keyStoretype">
                           <th mat-header-cell *matHeaderCellDef> Key Store Type </th>
                           <td mat-cell *matCellDef="let element"> {{element?.ksType}} </td>
                          </ng-container>
                          <ng-container matColumnDef="keyType">
                            <th mat-header-cell *matHeaderCellDef> Key Type </th>
                            <td mat-cell *matCellDef="let element">{{element?.keyType}} </td>
                           </ng-container>
                          
                         
                          <ng-container matColumnDef="keySize" >
                            <th mat-header-cell *matHeaderCellDef>Key Size</th>
                            <td mat-cell *matCellDef="let element"> {{element?.keySize}} </td>
                           </ng-container>
                           <ng-container matColumnDef="keyNameAlias" >
                            <th mat-header-cell *matHeaderCellDef>Key Name/Alias</th>
                            <td mat-cell *matCellDef="let element"> {{element?.keyAlias}} </td>
                           </ng-container>
                         
                          
                          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                          <ng-container matColumnDef="expandedDetail">
                          <td mat-cell *matCellDef="let element" [attr.colspan]="columnsDataEncryptDisplay.length">
                          <div class="example-element-detail row"
                           [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                          
                          </div>
                          </td>
                          </ng-container>
                          
                          <tr mat-header-row *matHeaderRowDef="columnsDataEncryptDisplay"></tr>
                          <tr mat-row *matRowDef="let element; columns: columnsDataEncryptDisplay;"
                          class="example-element-row">
                          </tr>
                          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                          <tr class="mat-row" *matNoDataRow>
                          <td  class="mat-cell" colspan="4">There is no data in this table</td>
                          </tr>
                          </table>
                          
                          
                          </div>
                          
                      
                    
                    </div> 
                      </div>
                     
                    </div>
                    </div>
                </div>

                <div class="modal " id="myMod"  [style.display]="showDataEncryptPopup ? 'block' : 'none'" >
                  <div class="modal-dialog" >
                      <div class="modal-content " >
                          <div class="modal-header title">
                            <h4 *ngIf="action==='newEncrypt'" class="modal-title">Add Data Encryption Keys</h4>
                            <h4 *ngIf="action==='updateEncrypt'" class="modal-title">Data Encryption Keys</h4>

                            <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                            </div>
                            <div class="modal-body">
                            <div class="col-md-12 mt-3 " *ngIf="showDataEncryptPopup">
                              <div class="col-md-12 d-flex justify-content-center" >
                              <div class="col-md-12 row " >
                                  <div class=" col-md-12 ">
                                      <form [formGroup]="DataEncryptRegFg"  (ngSubmit)="AddDataEncrypt()" autocomplete="off"  class=" row" >
                                        <mat-form-field class="col-md-4" appearance="outline">
                                          <mat-label>Key Store Type</mat-label>
                                          <mat-select matNativeControl name="keystoretype" formControlName="keystoreType">
                                            <mat-option value="PKCS12">PKCS12</mat-option>

                                          </mat-select>  
                                          <small *ngIf="DataEncryptRegFg.controls['keystoreType'].dirty && DataEncryptRegFg.controls['keystoreType'].invalid" class="warn">Please Select Key Store Type!</small>

                                        </mat-form-field>
                                        <mat-form-field class="col-md-4" appearance="outline">
                                          <mat-label>Key Store Name</mat-label>
                                          <input matInput type="text"  name="storeName" [readonly]="action==='updateEncrypt'" autocomplete="off" formControlName="keystoreName">
                                          <small *ngIf="DataEncryptRegFg.controls['keystoreName'].dirty && DataEncryptRegFg.controls['keystoreName'].invalid" class="warn">Please Enter Key Store Name!</small>

                                        </mat-form-field>
                                        
                                        <mat-form-field class="col-md-4" appearance="outline">
                                          <mat-label>Key Type</mat-label>
                                          <mat-select matNativeControl name="keytype" formControlName="keyType">
                                            <mat-option value="AES">AES</mat-option>
                                          </mat-select>  
                                          <small *ngIf="DataEncryptRegFg.controls['keyType'].dirty && DataEncryptRegFg.controls['keyType'].invalid" class="warn">Please Select Key Type!</small>

                                        </mat-form-field>   
                                        <mat-form-field class="col-md-4" appearance="outline">
                                            <mat-label>Key Size</mat-label>
                                            <mat-select matNativeControl name="keySize" formControlName="keySize">
                                                <mat-option value="256">256</mat-option>
                                                <mat-option value="512">512</mat-option>

                                              </mat-select> 
                                              <small *ngIf="DataEncryptRegFg.controls['keySize'].dirty && DataEncryptRegFg.controls['keySize'].invalid" class="warn">Please Select Key Size!</small>

                                          </mat-form-field> 
                                          <mat-form-field class="col-md-4" appearance="outline">
                                            <mat-label>Key Name/Alias</mat-label>
                                            <input matInput type="text"  name="alias" [readonly]="action==='updateEncrypt'" autocomplete="off" formControlName="keyAlias">
                                            <small *ngIf="DataEncryptRegFg.controls['keyAlias'].dirty && DataEncryptRegFg.controls['keyAlias'].invalid" class="warn">Please Enter Key Name/Alias!</small>

                                          </mat-form-field> 
                                          <mat-form-field *ngIf="action==='newEncrypt'" class="col-md-4" appearance="outline">
                                            <mat-label>Key Store Password Prefix</mat-label>
                                            <input matInput type="text"  name="storePrefix" autocomplete="off" formControlName="keystorePwdPrefix">
                                            <small *ngIf="DataEncryptRegFg.controls['keystorePwdPrefix'].dirty && DataEncryptRegFg.controls['keystorePwdPrefix'].invalid" class="warn">Please Enter Key Store Password Prefix!</small>

                                          </mat-form-field> 
                                          <mat-form-field *ngIf="action==='newEncrypt'" class="col-md-4" appearance="outline">
                                            <mat-label>Key Store Password Suffix</mat-label>
                                            <input matInput type="text"  name="storeSuffix" autocomplete="off" formControlName="keystorePwdSuffix">
                                            <small *ngIf="DataEncryptRegFg.controls['keystorePwdSuffix'].dirty && DataEncryptRegFg.controls['keystorePwdSuffix'].invalid" class="warn">Please Enter Key Store Password Suffix!</small>

                                          </mat-form-field> 
                                          <mat-form-field *ngIf="action==='newEncrypt'" class="col-md-4" appearance="outline">
                                            <mat-label>Key Password Prefix</mat-label>
                                            <input matInput type="text"  name="Prefix" autocomplete="off" formControlName="keyPwdPrefix">
                                            <small *ngIf="DataEncryptRegFg.controls['keyPwdPrefix'].dirty && DataEncryptRegFg.controls['keyPwdPrefix'].invalid" class="warn">Please Enter Key Password Prefix!</small>

                                          </mat-form-field> 
                                          <mat-form-field *ngIf="action==='newEncrypt'" class="col-md-4" appearance="outline">
                                            <mat-label>Key Password Suffix</mat-label>
                                            <input matInput type="text"  name="suffix" autocomplete="off" formControlName="keyPwdSuffix">
                                            <small *ngIf="DataEncryptRegFg.controls['keyPwdSuffix'].dirty && DataEncryptRegFg.controls['keyPwdSuffix'].invalid" class="warn">Please Enter Key Password Suffix!</small>

                                          </mat-form-field> 
                                          <mat-form-field *ngIf="action==='updateEncrypt'" class="col-md-4" appearance="outline">
                                            <mat-label>Creation Date</mat-label>
                                            <input matInput type="text" readonly  name="storeSuffix" autocomplete="off" [(ngModel)]="creationDate" [ngModelOptions]="{standalone: true}">

                                          </mat-form-field>                          
                                        </form>
                                  </div>
                                  </div>
                                  </div>                                      
                            </div>

                              <div class="modal-footer">
                                <div class="col-md-12 row" *ngIf="action==='updateEncrypt'">
                                <div class="col-md-6">
                                <button type="button"  class="btn btn-danger" mdbRipple (click)="UpdateStatus()">Delete</button>
                              </div>
                             <div class="col-md-6 d-flex justify-content-end">
                              <div class="col-md-12 row d-flex justify-content-end">
                              <div class="col-md-6 pt-2 d-flex justify-content-end">               
                                <mat-slide-toggle  style="font-size: 14px;"  [(ngModel)]="Default" (click)="UpdateDefault()">Default</mat-slide-toggle>
                              </div>
                            <div class="col-md-3  d-flex justify-content-end">
                              <button  type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                          </div>
                              </div>
                              </div>
                                </div>
                             
                                <button *ngIf="action==='newEncrypt'" class="btn btn-outline-success c-width-100px shadow "  (click)="AddDataEncrypt()" [disabled]="DataEncryptRegFg.invalid">Save</button>
                              <button *ngIf="action==='newEncrypt'" type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                         
                              </div>
                            </div>
                            </div>
                    </div>
                </div>
                